import { ChartContainer } from './ChartContainer';
import { ArrowRight } from 'lucide-react';

export const FunnelChart = ({ data }) => {
  return (
    <ChartContainer 
      title="Registration Funnel" 
      subtitle="Conversion journey"
    >
      <div className="space-y-3" data-testid="funnel-chart">
        {data.map((step, index) => {
          const isFirst = index === 0;
          const isLast = index === data.length - 1;
          const width = `${(step.count / data[0].count) * 100}%`;
          
          return (
            <div key={index} className="space-y-1.5">
              <div className="flex items-center justify-between text-sm font-manrope">
                <span className={`${isLast ? 'text-primary font-medium' : 'text-foreground'}`}>
                  {step.step}
                </span>
                <div className="flex items-center gap-2">
                  <span className="text-muted-foreground">
                    {step.count.toLocaleString()}
                  </span>
                  <span className={`text-xs px-1.5 py-0.5 rounded ${
                    isFirst 
                      ? 'bg-secondary text-muted-foreground' 
                      : isLast 
                        ? 'bg-primary/20 text-primary' 
                        : 'bg-secondary text-muted-foreground'
                  }`}>
                    {step.percentage}%
                  </span>
                </div>
              </div>
              <div className="relative h-6 bg-secondary/50 rounded overflow-hidden">
                <div 
                  className="absolute inset-y-0 left-0 rounded transition-all duration-700 ease-out"
                  style={{ 
                    width,
                    background: isLast 
                      ? 'linear-gradient(90deg, hsl(42, 48%, 56%) 0%, hsl(42, 48%, 66%) 100%)'
                      : 'hsl(140, 6%, 20%)'
                  }}
                />
                {!isLast && (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2">
                    <ArrowRight className="w-3 h-3 text-muted-foreground/50" />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Conversion highlight */}
      <div className="mt-6 p-4 bg-primary/10 rounded-lg border border-primary/20">
        <div className="flex items-center justify-between">
          <span className="text-sm font-manrope text-muted-foreground">Overall Conversion Rate</span>
          <span className="text-2xl font-manrope font-bold text-primary">
            {((data[data.length - 1].count / data[0].count) * 100).toFixed(2)}%
          </span>
        </div>
      </div>
    </ChartContainer>
  );
};
